<template>
  <AccessModeBanner />
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'
import { isAuthenticated } from '@/utils/auth'
import useEntitlements from '@/composables/useEntitlements'
import AccessModeBanner from '@/components/AccessModeBanner.vue'

const entitlementStore = useEntitlements()

onMounted(() => {
  if (isAuthenticated()) {
    entitlementStore.fetchEntitlements().catch(() => {
      // Non-blocking banner hydration.
    })
  }
})
</script>

<style>
body {
  margin: 0;
  font-family: 'Inter', sans-serif;
}
</style>
